type RequiredFields = {
  iterations: { id: number }[]
}

/**
 * Returns the final iteration of a submission
 */
export const getCurrentIteration = <T extends RequiredFields>(submission: T): T['iterations'][0] | undefined => {
  if (!submission || submission.iterations.length === 0) return undefined

  return submission.iterations.reduce((prev, current) => {
    return prev.id > current.id ? prev : current
  })
}
